import { RouteConfig } from 'vue-router';

const PAGE_TITLE = '全民必答！新型冠状病毒防护考试全国卷来了';

const route: RouteConfig = {
  path: '/2020nCoVExam',
  name: '2020nCoVExam',
  component: () => import('./ViewHolder.vue'),
  redirect: '/2020nCoVExam/Home',
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'Home',
      name: '2020nCoVExam_Home',
      component: () => import('./Home.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
